module.exports = __webpack_public_path__ + "static/media/wow-logo.dfd1d43b.png";